import { Link } from 'react-router-dom';

const FinalCTA = () => {
  return (
    <section className="py-16 bg-gradient-to-r from-primary to-secondary">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          ¿Necesitas vaciar un piso en Mollet del Vallès?
        </h2>

        <p className="text-white/90 text-lg md:text-xl mb-8">
          Contacta con nosotros y recibe tu presupuesto personalizado sin compromiso en menos de 24 horas. Si necesitas un <a href="https://cerdanyola.justclean.es/" target="_blank" rel="noopener noreferrer" className="underline hover:text-white font-semibold transition-colors">vaciado de piso o local en Mollet del Vallès</a>, estamos aquí para ayudarte.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-6">
          <a
            href="tel:+34602365996"
            className="inline-flex items-center justify-center space-x-2 bg-white text-primary px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-fill text-xl"></i>
            <span>Llamar Ahora</span>
          </a>

          <Link
            to="/contacto"
            className="inline-flex items-center justify-center space-x-2 border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-primary transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-file-text-line text-xl"></i>
            <span>Solicitar Presupuesto</span>
          </Link>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-white/80 text-sm">
          <div className="flex items-center space-x-2">
            <i className="ri-checkbox-circle-fill text-white"></i>
            <span>Presupuesto sin compromiso</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-checkbox-circle-fill text-white"></i>
            <span>Servicio discreto</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-checkbox-circle-fill text-white"></i>
            <span>Disponibilidad inmediata</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
